<template>
  <BoxCard class="performance-summary-widget mb-2">
    <template #header>
      <div class="relative full-width">
        <h4>Tech Leaderboard</h4>
        <div class="tooltip-icon">
          <Tooltip>
            <template #trigger>
              <i class="fas fa-info-circle"></i>
            </template>
            <template #tooltip>
              <div><MetricsTooltipMobile /></div>
            </template>
          </Tooltip>
        </div>
      </div>
    </template>
    <template #body>
      <div class="md:max-h-[72svh] overflow-auto">
        <TechLeaderboard
          :tech-leaderboard="leaderboardData"
          :loading="dashboardLoading"
        />
      </div>
    </template>
  </BoxCard>
</template>

<script>
import { mapActions, mapState } from "vuex";

import BoxCard from "@/components/BoxCard.vue";
import Tooltip from "@/components/Tooltip.vue";
import { breakpoints } from "@/mixins";
import MetricsTooltipMobile from "./MetricsTooltipMobile.vue";

export default {
  components: {
    BoxCard,
    Tooltip,
    MetricsTooltipMobile
  },
  computed: {
    ...mapState(["dashboardFilters", "dashboardData", "dashboardLoading"]),
    leaderboardData() {
      return this.dashboardData.leaderboard
        ? this.dashboardData.leaderboard.data
        : [];
    }
  },
  methods: {
    ...mapActions(["fetchTechLeaderboard"]),
    isMobileScreenSize() {
      return breakpoints().sm;
    }
  }
};
</script>

<style lang="scss" scoped>
.tooltip-icon {
  position: absolute;
  right: 10px;
  color: var(--darkblue);
  top: 3px;
}
</style>
